function normalizeAsset(asset) {
  if (!asset) return '';
  if (/^(https?:|data:|blob:)/i.test(asset)) return asset;
  return `./${String(asset).replace(/^\.?\//, '')}`;
}

function formatDelta(change) {
  const value = Number(change.delta || 0);
  const sign = value > 0 ? '+' : '';
  const absolute = Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  return `${sign}${change.prefix || ''}${absolute}${change.suffix || ''}`;
}

export function SceneEncounter({ event, busy, onChoose }) {
  const focal = event.focalPoint || { x: 0.5, y: 0.5 };
  const position = `${Math.round(Number(focal.x ?? 0.5) * 100)}% ${Math.round(Number(focal.y ?? 0.5) * 100)}%`;
  const body = Array.isArray(event.body) ? event.body : [event.body].filter(Boolean);

  return (
    <div className={`scene-overlay scene-tone-${event.tone || 'neutral'}`} role="dialog" aria-modal="true" aria-labelledby="scene-title">
      <div className="scene-frame">
        <div className="scene-artwork">
          <img src={normalizeAsset(event.imageAsset)} alt="" style={{ objectPosition: position }} />
          <div className="scene-vignette" />
          <div className="scene-label">SCENE ENCOUNTER</div>
        </div>
        <div className="scene-lower">
          <section className="scene-dialogue">
            <span className="scene-kicker">STREET ENCOUNTER</span>
            <h2 id="scene-title">{event.title}</h2>
            <div className="scene-copy">
              {body.map((line, index) => <p key={`${index}-${line}`}>{line}</p>)}
            </div>
          </section>
          <section className="scene-choices" aria-label="Encounter choices">
            {event.choices?.map((choice, index) => (
              <button
                key={choice.id}
                className="scene-choice"
                disabled={busy || !choice.available}
                onClick={() => onChoose(choice.id)}
              >
                <span className="scene-choice-number">{index + 1}.</span>
                <span className="scene-choice-copy">
                  <strong>{choice.label}</strong>
                  {!choice.available && choice.requirement && <small>{choice.requirement}</small>}
                </span>
              </button>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}

export function SceneOutcome({ outcome, onContinue }) {
  return (
    <div className="scene-outcome-overlay" role="dialog" aria-modal="true" aria-labelledby="scene-outcome-title">
      <section className="scene-outcome-card">
        <span className="scene-kicker">ENCOUNTER RESULT</span>
        <h2 id="scene-outcome-title">{outcome.title}</h2>
        <p>{outcome.message}</p>
        {outcome.changes?.length > 0 && (
          <div className="scene-outcome-chips" aria-label="Outcome changes">
            {outcome.changes.map((change, index) => (
              <span key={`${change.label}-${index}`} className={Number(change.delta) >= 0 ? 'positive' : 'negative'}>
                <strong>{change.label}</strong> {formatDelta(change)}
              </span>
            ))}
          </div>
        )}
        <button className="responsive-primary" onClick={onContinue}>Continue</button>
      </section>
    </div>
  );
}
